import { actionGenerator, IReduxAction } from '../../utils/actions';

export const SET_IS_SUBAGENT_NOT_ENOUGH_MONEY = 'PUBLISH_INFO :: SET_IS_SUBAGENT_NOT_ENOUGH_MONEY';

export type TSetIsSubagentNotEnoughMoney = IReduxAction<typeof SET_IS_SUBAGENT_NOT_ENOUGH_MONEY, boolean>;

export const setIsSubagentNotEnoughMoney = actionGenerator<typeof SET_IS_SUBAGENT_NOT_ENOUGH_MONEY, boolean>(
  SET_IS_SUBAGENT_NOT_ENOUGH_MONEY,
);
